module.exports = __webpack_public_path__ + "img/br.64ab05d8.svg";